import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Shop from "./components/Shop";
import { Input } from "./components/ui/input";
import { useEffect, useState } from "react";
import { toast, Toaster } from "sonner";
import { GetAllData, SendToFirebase } from "./firebase/functions";
import { Button } from "./components/ui/button";
import { Badge } from "./components/ui/badge";

const Home = () => {
  return <Shop />;
};

const AddItems = () => {
  const [tag, settag] = useState([]);
  const [title, settitle] = useState();
  const [url, seturl] = useState();
  const [image, setimage] = useState();
  const [loader, setloader] = useState(false);
  const [categories, setcategories] = useState([]);
  const [updateComponent, setupdateComponent] = useState(false);

  const [tags, settags] = useState("");

  function handleAddItems() {
    if (!tag.length) {
      toast.warning("tags cannot be empty.");
      return;
    }
    if (!title) {
      toast.warning("title cannot be empty.");
      return;
    }
    if (!image) {
      toast.warning("image cannot be empty.");
      return;
    }
    if (!url) {
      toast.warning("url cannot be empty.");
      return;
    }
    setloader(true);
    SendToFirebase("products", {
      title,
      tag,
      image,
      date: new Date().getTime(),
      link: url,
    })
      .then((data) => {
        console.log(data);
        if (data.id) {
          toast.success("Items has been added");
        }
        setloader(false);
      })
      .catch((err) => {
        toast.error("Unable to add Items");
        console.log("err: ", err);
        setloader(false);
      });
  }

  useEffect(() => {
    GetAllData("toics")
      .then(({ docs }) => {
        const data = [];
        docs.forEach((v) => {
          data.push({ ...v.data(), id: v.id });
        });
        setcategories(data);
      })
      .catch((err) => {
        console.log("get topics: ", err);
      });
  }, [updateComponent]);

  return (
    <div className="bg-black text-white h-screen w-full p-3">
      <div className="flex justify-center w-full my-3 sm:flex-nowrap flex-wrap items-center gap-3">
        <Input
          onChange={(e) => settitle(e.target.value)}
          placeholder="Enter title"
        />
        <Input
          onChange={(e) => seturl(e.target.value)}
          placeholder="Enter link"
        />
      </div>
      <div className="flex justify-center w-full my-3 sm:flex-nowrap flex-wrap items-center gap-3">
        <Input
          onChange={(e) => setimage(e.target.value)}
          placeholder="Enter image url"
        />
        <div className="w-full">
          <Input
            id="tags"
            onKeyDown={(e) => {
              console.log(e.code);
              if (e.code === "Enter") {
                settag((prev) => [...prev, e.target.value]);
                setTimeout(() => {
                  document.getElementById("tags").value = "";
                }, 200);
                // e.target.value = ''
              }
            }}
            placeholder="Enter tags"
          />
          <div className="mt-1 flex justify-start items-center gap-2 flex-wrap">
            {tag.map((v, i) => (
              <Badge
                onClick={() => {
                  const updated = tag.filter((s) => s !== v);
                  settag(updated);
                }}
                className="category-badge cursor-pointer"
              >
                {v}
              </Badge>
            ))}
          </div>
        </div>
      </div>
      <Button onClick={handleAddItems} className="my-2" disabled={loader}>
        {loader ? "Adding..." : "Add Items"}
      </Button>

      <div className="my-4">
        <div className="flex justify-center w-full my-3  items-center gap-3">
          <Input
            value={tags}
            onChange={(e) => settags(e.target.value)}
            placeholder="Enter tag name"
          />
          <Button
            onClick={() => {
              if (!tags) {
                return toast.warning("tag cannot be empty.");
              }
              setloader(true);
              SendToFirebase("toics", {
                date: new Date().getTime(),
                name: tags,
                id: categories.length + 1,
              })
                .then(() => {
                  setloader(false);
                  toast.success("New tag has been added.");
                  setupdateComponent(!updateComponent);
                })
                .catch((error) => {
                  console.log("tags error: ", error);
                  setloader(false);
                });
            }}
            className="my-2"
            disabled={loader}
          >
            {loader ? "Adding..." : "Add Tags"}
          </Button>
        </div>
        <div className="mt-1 flex justify-start items-center gap-2 flex-wrap">
          {categories.map((v, i) => (
            <Badge className=" cursor-pointer">{v.name}</Badge>
          ))}
        </div>
      </div>
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/add-product" element={<AddItems />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
